/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE:

 * All information contained herein is, and remains
* the property of Advenio Tecnosys and its suppliers,
* if any.  The intellectual and technical concepts contained
* herein are proprietary to Advenio Tecnosys
* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,
* patents in process, and are protected by trade secret or copyright law.
* Appropriation, redistribution, dissemination of this information or reproduction
* of this material is strictly forbidden unless prior written permission is obtained
* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ujjwal Singh >

*/

// ponytail: focused label color keyed to a fixed dark slate (blueGrey[900],
// the value of palette.text.primary in all three palettes) instead of
// palette.primary.main, so a broken palette.primary.main (e.g. blueTheme
// #f5f5f5) can't make focused labels invisible. Targets MuiFormLabel (the
// component that defines the focused color via &$focused at 0,2,0
// specificity) — overriding MuiInputLabel.focused (0,1,0) loses the cascade.
// Upgrade path: fix palette.primary.main to a real contrast color, then this
// override can go.
export default {
  root: {
    '&$focused': {
      color: '#263238',
    },
    '&$error': {
      color: '#d32f2f',
    },
    '&$error.Mui-focused, &$focused.Mui-error': {
      color: '#d32f2f',
    },
  },
};